/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actions from "store/actions/company";
import IMei from "Types/IMei";

export interface CompanyState {
	items: IMei[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: CompanyState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_COMPANIES: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_COMPANIES_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_COMPANIES_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
